import AppConstants from "./AppConstants";
import RouteConstants from "./RouteConstants";
import PlanningConstants from "./PlanningConstants";
import LoginConstants from "./LoginConstants";
import UsersConstants from "./UsersConstants";
import CodReconciliationConstants from "./CodReconciliationConstants";
import DashboardConstants from "./PerformanceConstants";
import TrackingConstants from "./TrackingConstants";
import HubConstants from "./HubConstants";
import HubDashboardConstants from "./HubDashboardConstant";
import ClickAndCollectConstants from "./ClickAndCollectConstants";
import DelveConstants from "./DelveConstants";
import CustomerCommConstants from "./CustomerCommunications";
import ExpressConstants from "./ExpressConstants";
import DriversConstants from "./DriversConstants";
import CODPortalConstants from "./CODPortalConstants";
import StdCodPortalConstants from "./StdCodPortalConstants";
import StagingAreaConstants from "./StagingAreaConstants";
import StoreManagementConstant from "./StoreManagementConstant";
import ReportConstants from "./ReportConstants";
import DriverHelperTipConstants from "./DriverHelperTipConstants";
import ConsignmentConstants from "./ConsignmentConstants";
import ReturnConstants from "./ReturnConstants";
import OnBoardingConstants from "./OnBoardingConstants";

export default {
  ...AppConstants,
  ...RouteConstants,
  ...PlanningConstants,
  ...UsersConstants,
  ...CodReconciliationConstants,
  ...DashboardConstants,
  ...LoginConstants,
  ...TrackingConstants,
  ...HubConstants,
  ...HubDashboardConstants,
  ...ClickAndCollectConstants,
  ...DelveConstants,
  ...ExpressConstants,
  ...DriversConstants,
  ...CODPortalConstants,
  ...StdCodPortalConstants,
  ...StagingAreaConstants,
  ...CustomerCommConstants,
  ...StoreManagementConstant,
  ...ReportConstants,
  ...DriverHelperTipConstants,
  ...ConsignmentConstants,
  ...ReturnConstants,
  ...OnBoardingConstants
};
